const {findOptionalArgument} = require("../util/ParserHelpers");

const makeParser = function(settings = {}) {
	return function(ps) {
		const optArg1 = findOptionalArgument(ps);
		const optArg2 = findOptionalArgument(ps);
		const scaleFactor = optArg1 ? parseFloat(optArg1.getRest()) : 0.5;
		const lineWidth = optArg2 ? parseFloat(optArg2.getRest()) : 1;
		return [
			{
				type: "circle",
				scale: scaleFactor,
				lineWidth: lineWidth,
				children: [],
				...settings,
			},
		];
	};
};

const circleNode = {
	draw(rc, x, y, node, measure) {
		const {top} = measure;
		rc.context.lineWidth = node.lineWidth;
		if (node.isOpen) {
			rc.context
				.bp()
				.arc(x + top, y, top, 0, Math.PI * 2)
				.stroke();
		} else {
			rc.context
				.bp()
				.arc(x + top, y, top, 0, Math.PI * 2)
				.stroke()
				.fill();
		}
	},
	measure(rc, fontInfo, props, node) {
		const fontSize = fontInfo.size;
		return {
			width: fontSize * node.scale * 2,
			top: fontSize * node.scale,
			bottom: fontSize * node.scale,
			fontInfo,
		};
	},
	// readAloud: probably need to read the color somehow
	readAloud: "circle",
};

module.exports = {
	parsers: {
		mathCommands: {
			circle: makeParser({isOpen: true}),
			fcircle: makeParser(),
		},
		nonmathCommands: {
			circle: makeParser({isOpen: true}),
			fcircle: makeParser(),
		},
	},
	nodes: {
		circle: circleNode,
	},
};
